import apiClient from './client';

/**
 * Submit an email to an interest list.
 * 
 * @param {Object} data - The interest form data
 * @param {string} data.email - Email address
 * @param {string} data.interest_type - Type: 'teacher', 'feature_x', 'other'
 * @param {string|null} data.clerk_user_id - Optional Clerk user ID
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const submitInterest = async (data) => {
  const response = await apiClient.post('/interest', data);
  return response.data;
};

